import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'

const ScriptedTestConfigGlobalParamsDescription = () => window.location.protocol === 'https:'
  ? (
    <Paragraph>
      <Color variant='theme-description-text'>
        To use a global parameter, click on the name chips above to copy them in the correct format and paste them into the custom value fields.
      </Color>
      <br />
      <Color variant='theme-description-text'>
        Alternatively, you can enter the global parameter names manually using SenseTalk syntax
      </Color>
      {' '}<Color variant='theme-description-text'><strong>[[global-parameter-name]]</strong>.</Color>
    </Paragraph>
  )
  : (
    <Paragraph>
      <Color variant='theme-description-text'>
        To use a global parameter, enter the global parameter names using SenseTalk syntax
      </Color>
      {' '}<Color variant='theme-description-text'><strong>[[global-parameter-name]]</strong>.</Color>
    </Paragraph>
  )

export default ScriptedTestConfigGlobalParamsDescription
